import { Component, OnInit } from '@angular/core';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { MatomoTracker } from 'ngx-matomo';
import { LayoutComponent } from 'src/app/layout/layout.component';

@Component({
  selector: 'app-wmsm-PMCSPage',
  templateUrl: './wmsm-PMCSPage.component.html',
  styleUrls: ['./wmsm-PMCSPage.component.scss']
})
export class WmsmPMCSPageComponent extends BaseComponent implements OnInit {
  fileList: NzUploadFile[] = [];
  loading: boolean = false;
  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  constructor(
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private messageService: NzMessageService,
    private AuthService: AuthService,
    private fb: FormBuilder,
    private http: HttpClient,
    private matomotracker: MatomoTracker,
    private LayoutComponent: LayoutComponent,
  ) { super() }

  ngOnInit() {
    // this.matomotracker.trackPageView("pmcs")
    // this.matomotracker.trackEvent("pmcs","pmcs Link","Transation",1);
    // window.location.href = 'http://pmcsweb.wistron.com'
    window.open("http://pmcsweb.wistron.com")
    this.LayoutComponent.geturl()
    this.matomotracker.trackPageView("系統管理員權限設置")
    this.matomotracker.trackEvent("系統管理員權限設置", "供應商帳號失效結案", "Transation", 1);
  }
  beforeUpload = (file: NzUploadFile): boolean => {
    this.saveExcelData(file);
    return false;
  };
  // 保存表格中的数据
  saveExcelData(file) {
    this.loading = true;
    const formData = new FormData();
    formData.append('file', file);
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.VendorAccountDisableClose.url}`;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse))
      .subscribe(
        (res) => {
          if (res['body'].status == this.Environment.authConfig.wmsmStatus) {
            this.messageService.success(res['body'].msg);
          } else {
            this.messageService.warning(res['body'].msg);
          }
          this.loading = false;
        },
        (error) => {
          this.messageService.error('upload failed.');
          this.loading = false;
        }
      );
  }

  DownloadExample() {

    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownloadVendorAccountDisable.url}`;
    const params = {
    };
    this.webApiService.doPost(url, params, true).subscribe((res) => {
      this.downloadFile8(res, `wmsm_Example${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }

}
